import React from 'react';
import TelephoneLink from './TelephoneLink';

interface IDefinitionRowProps {
    title: string;
    description: any;
    isTelephoneLink?: boolean;
    display?: boolean;
}

const DefinitionRow: React.FC<IDefinitionRowProps> = ({
    title,
    description,
    isTelephoneLink = false,
    display = true,
}) => {
    if (!display || !title) return null;

    if (!description) description = '-';

    return (
        <div className="dl-item">
            <div className="dl-title">{title}</div>
            <div className="dl-description">
                {isTelephoneLink ? <TelephoneLink>{description}</TelephoneLink> : description}
            </div>
        </div>
    );
};

export default DefinitionRow;
